import { cva, type VariantProps } from "./style.utils";

// -----------------------------------------------------------------------------

export type FieldMessageVariants = VariantProps<typeof fieldMessageVariants>;

export const fieldMessageVariants = cva({
  base: "flex gap-4px text-xs empty:invisible empty:absolute",
  variants: {
    intent: {
      unset: null,
      subtle: "text-shade-80",
      error: "text-error-100",
      warning: "text-warning-120",
      success: "text-success-120",
      info: "text-info-100",
      help: "text-neutral-100",
    },
  },
});

// -----------------------------------------------------------------------------

export type FieldMessageIconVariants = VariantProps<
  typeof fieldMessageIconVariants
>;

export const fieldMessageIconVariants = cva({
  base: "translate-y-2px",
  variants: {
    intent: {
      unset: null,
      subtle: "text-shade-90",
      error: "text-error-120",
      warning: "text-warning-120",
      success: "text-success-120",
      info: "text-info-120",
      help: "text-neutral-120",
    },
  },
});
